var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("加载中...")]):(_vm.error)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),(!_vm.loading && !_vm.error && Object.keys(_vm.privData).length > 0)?_c('scheduled-tasks-form',{attrs:{"privData":_vm.privData},on:{"submit":_vm.submitForm}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }